export interface SolutionCapabilityElement {
    id: string;
    name: string;
}

export const solutionCapabilities: SolutionCapabilityElement[][] = [
    // Data & Analytics
    [
        {
            id: '68827868890be11c1d2ffa72',
            name: 'Interoperability'
        },
        {
            id: '6882785835e63fb8e6a6c3f4',
            name: 'Machine Learning and AI'
        },
        {
            id: '6882784350c0f85365493096',
            name: 'Data Availability and Reliability'
        },
        {
            id: '6882782e5eccba3423fc440a',
            name: 'Data & Analytics Integration and Democratization'
        }
    ],
    // Clinical Quality
    [
        {
            id: '68828128d2a3356feb15aa77',
            name: 'Inpatient Performance Improvement'
        },
        {
            id: '6882810d33ca04017ae5ce34',
            name: 'Surgical Quality & Efficiency '
        },
        {
            id: '688280ebdd1c785426a00792',
            name: 'Patient Safety'
        },
        {
            id: '688280d90bab37c081ca5313',
            name: 'Chronic & Acute Disease Management'
        }
    ],
    // Revenue & Cost
    [
        {
            id: '6882858fc2766251d768f44d',
            name: 'Clinical Cost Variation'
        },
        {
            id: '6882857c2024300e2486c793',
            name: 'Labor Efficiency'
        },
        {
            id: '688285680bab37c081cc5687',
            name: 'Supply Chain Optimization'
        },
        {
            id: '688285454d24bc6db566b2c2',
            name: 'Chargemaster Management'
        },
        {
            id: '688285329a7fcfdf3bc3ce12',
            name: 'Revenue Cycle Health & Integrity '
        }
    ],
    // Population Health & Value-Based Care
    [
        {
            id: '6882639ac3e4163567cd2c04',
            name: 'Network Management'
        },
        {
            id: '688263754ce079d09291e825',
            name: 'Patient Engagement Efficiency'
        },
        {
            id: '6882635ba91af44aee9d52be',
            name: 'Value-Based Care Performance'
        },
        {
            id: '688263405204bf8cb6424713',
            name: 'Care Transformation'
        },
        {
            id: '688262f2ca421a388a77bcca',
            name: 'Population Health Management'
        }
    ],
    // Regulatory & Cybersecurity
    [
        {
            id: '68827d52cf1059fe4d8147e4',
            name: 'Price Transparency'
        },
        {
            id: '68827d3e4b18dd8a25ffc56f',
            name: 'Cybersecurity and Risk Management'
        },
        {
            id: '68827d2d4b18dd8a25ffbdf4',
            name: 'Registry Performance'
        },
        {
            id: '68827d1dcec899cd65ec6871',
            name: 'Quality Performance and Measures'
        }
    ]
];